import { BaseClient } from '@/api'
import request from '@/utils/request'

export class CardClient extends BaseClient {
  constructor(
  ) {
    super('cards')
  }

  async getByCardNumber(cardNumber: any): Promise<any> {
    const cardList : any = await request({
      url: `/${this.path}`,
      method: 'get',
      params: {
        filter: {
          where: { card_number: cardNumber } } }
    })
    if (cardList.length > 0) {
      return cardList[0]
    } else {
      return null
    }
  }

  async replacement(data: any): Promise<any> {
    return request({
      url: `/${this.path}/replacement`,
      method: 'put',
      data
    })
  }
}
